import { setDefaultAuthMethod } from '@m/utils/http';

setDefaultAuthMethod('token');

export { default } from './PortalApp';
